export const isProduction =
  process.env.DEPLOY_STAGE === "staging" ||
  process.env.DEPLOY_STAGE === "production"

export const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.DEPLOY_STAGE === "development" ||
  process.env.DEPLOY_STAGE === undefined
